import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <main className="contact-page">
      <h2 className="contact-title">Nous Contacter</h2>

      <div className="contact-container">
        {/* Section Informations de Contact */}
        <div className="contact-info">
          <div className="contact-item">
            <span className="contact-icon">📍</span>
            <div>
              <h3>Adresse</h3>
              <p>332 BD BRAHIM ROUDANI, MAARIF</p>
              <p>CASABLANCA</p>
            </div>
          </div>

          <div className="contact-item">
            <span className="contact-icon">📧</span>
            <div>
              <h3>Adresse E-mail</h3>
              <p>contact@etoilebricolage.com</p>
            </div>
          </div>

          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <div>
              <h3>Téléphone</h3>
              <p>(+212)  6 60 41 19 27</p>
            </div>
          </div>
        </div>

        {/* Section Formulaire de Contact */}
        <div className="contact-form">
          <h3>Envoyez-nous Un Message</h3>
          <form>
            <input type="text" placeholder="Votre Nom" required />
            <input type="tel" placeholder="Votre Numéro de Téléphone" required />
            <input type="email" placeholder="Votre Adresse E-mail" required />
            <input type="text" placeholder="Objet du Message" required />
            <textarea placeholder="Votre Message" rows="5" required></textarea>
            <button type="submit" className="btn">Envoyer le Message</button>
          </form>
        </div>
      </div>
    </main>
  );
}

export default Contact;
